import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { removeUserData } from 'helpers/StorageHelper';
import { clearSidebarOrderMap } from 'modules/admin/components/Navbars/sidebarConfig';

interface AuthState {
  userInfo: object | null;
  profileInfo: object | null;
  fflInfo: object | null;
  userSettings: object | null;
}

const initialState: AuthState = {
  userInfo: null,
  profileInfo: null,
  fflInfo: null,
  userSettings: null,
};

export const AuthSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserAuthInfo: (state, action: PayloadAction<AuthState>) => {
      const userInfo: any = action.payload;
      state.userInfo = userInfo;
      if (userInfo?.user) {
        state.profileInfo = userInfo.user;
      }
      if (userInfo?.fflInfo) {
        state.fflInfo = userInfo.fflInfo;
      }
      if (userInfo?.user_settings) {
        state.userSettings = userInfo.user_settings;
      }
    },
    logoutUserState(state) {
      state.userInfo = null;
      state.profileInfo = null;
      state.fflInfo = null;
      clearSidebarOrderMap();
      removeUserData();
    },
  },
});

export const { setUserAuthInfo, logoutUserState } = AuthSlice.actions;
export default AuthSlice.reducer;
